import { WithdrawPostRequest } from "./request/withdrawPostRequest";

export class DividendsWithdrawModel extends WithdrawPostRequest {
  UserId: number;
  IndexType: number;
}